import { cn } from '@nexelem/utils';
import { Status, StatusProps } from './Status';

type StatusColumnProps = StatusProps & {
  className?: string;
};
export const StatusColumn = ({ className, ...statusProps }: StatusColumnProps) => (
  <div className={cn('flex h-full items-center justify-center', className)}>
    <Status {...statusProps} />
  </div>
);
